import React from "react";
import { Link, useLocation } from "react-router-dom";
import ScrollToTop from "../../ScrollToTop";
import AdminSidebar from "../../../Component/AdminSidebar";

const PilotageLayout = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath.startsWith(path);

  const [openSections, setOpenSections] = React.useState({
    Activite: isActive('/Pilotage/Synthese'),
    Encours: isActive('/Pilotage/Encours'),
    Articles: false,
    Comptabilite: isActive('/Pilotage/Compta'),
  });

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const NavHeader = ({ label, sectionKey }) => (
    <button 
      className="list-group-item list-group-item-action d-flex justify-content-between align-items-center fw-bold text-dark"
      style={{ backgroundColor: openSections[sectionKey] ? '#f8f9fa' : 'transparent', color: openSections[sectionKey] ? '#e67e22' : 'inherit' }}
      onClick={() => toggleSection(sectionKey)}
    >
      {label}
      <i className={`fas fa-chevron-${openSections[sectionKey] ? 'up' : 'down'} small text-muted`}></i>
    </button>
  );

  return (
    <div>
      <ScrollToTop />
      <section className="admin-section bg-light py-4" style={{ minHeight: "100vh" }}>
        <div className="container-fluid px-4">
          <div className="row">
            <AdminSidebar activePath="/Pilotage" />
            
            <div className="col-lg-9 col-md-8 col-12">
              <div className="row h-100">
                {/* Secondary Sidebar */}
                <div className="col-lg-3 col-md-4 mb-4 mb-md-0">
                  <div className="card border-0 shadow-sm rounded-3 h-100">
                    <div className="card-header bg-white border-bottom p-3">
                      <h5 className="mb-0 fw-bold" style={{ color: "#e67e22" }}>PILOTAGE</h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="list-group list-group-flush pilotage-nav">
                        <Link 
                          to="/Pilotage" 
                          className={`list-group-item list-group-item-action fw-bold ${currentPath === '/Pilotage' ? 'active text-white' : 'text-dark'}`}
                          style={currentPath === '/Pilotage' ? { backgroundColor: '#e67e22', borderColor: '#e67e22' } : {}}
                        >
                          Tableau de bord
                        </Link>
                        
                        <NavHeader label="Activité" sectionKey="Activite" />
                        {openSections.Activite && (
                          <div className="bg-light">
                            <Link 
                              to="/Pilotage/Synthese" 
                              className={`list-group-item list-group-item-action ps-4 border-0 ${isActive('/Pilotage/Synthese') ? 'fw-bold text-dark' : 'text-muted'}`}
                              style={isActive('/Pilotage/Synthese') ? { backgroundColor: '#f8f9fa', borderLeft: '4px solid #e67e22' } : {}}
                            >
                              Synthèse
                            </Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Par mode de paiement</Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Par article</Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Par catégorie</Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Par fournisseur</Link>
                          </div>
                        )}

                        <NavHeader label="Encours" sectionKey="Encours" />
                        {openSections.Encours && (
                          <div className="bg-light">
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Avoirs</Link>
                            <Link 
                              to="/Pilotage/Encours" 
                              className={`list-group-item list-group-item-action ps-4 border-0 ${isActive('/Pilotage/Encours') ? 'fw-bold text-dark' : 'text-muted'}`}
                              style={isActive('/Pilotage/Encours') ? { backgroundColor: '#f8f9fa', borderLeft: '4px solid #e67e22' } : {}}
                            >
                              Paiements différés
                            </Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Remboursements différés</Link>
                          </div>
                        )}

                        <NavHeader label="Articles" sectionKey="Articles" />
                        {openSections.Articles && (
                          <div className="bg-light">
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Ventes / Stocks</Link>
                          </div>
                        )}
                        
                        <NavHeader label="Comptabilité" sectionKey="Comptabilite" />
                        {openSections.Comptabilite && (
                          <div className="bg-light">
                            <Link 
                              to="/Pilotage/Compta" 
                              className={`list-group-item list-group-item-action ps-4 border-0 ${isActive('/Pilotage/Compta') ? 'fw-bold text-dark' : 'text-muted'}`}
                              style={isActive('/Pilotage/Compta') ? { backgroundColor: '#f8f9fa', borderLeft: '4px solid #e67e22' } : {}}
                            >
                              Export accounting
                            </Link>
                            <Link to="#" className="list-group-item list-group-item-action ps-4 border-0 text-muted">Tiroir caisse</Link>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Main Content Area */}
                <div className="col-lg-9 col-md-8">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PilotageLayout;
